import type { InscritoPresenca } from './types';

// Marcador gravado no início da observação quando a direção cancela a presença.
export const MOTIVO_CANCELAMENTO = 'Cancelada pela direção:';

// Filtro rápido por como a presença foi marcada / situação.
export type FiltroComo = 'todas' | 'qr' | 'foto' | 'direcao' | 'canceladas';

// Uma presença cancelada pela direção é uma recusada com o motivo marcado.
export function ehCancelada(l: InscritoPresenca): boolean {
  if (l.situacao !== 'recusada' || !l.observacao) return false;
  return l.observacao.trimStart().startsWith(MOTIVO_CANCELAMENTO);
}

// O motivo do cancelamento (o texto depois do marcador).
export function motivoDoCancelamento(l: InscritoPresenca): string {
  if (!l.observacao) return '';
  const i = l.observacao.indexOf(MOTIVO_CANCELAMENTO);
  if (i < 0) return l.observacao.trim();
  return l.observacao.slice(i + MOTIVO_CANCELAMENTO.length).trim();
}

function dois(n: number): string {
  return String(n).padStart(2, '0');
}

// "HH:MM" da marcação.
export function horaCurta(iso?: string | null): string {
  if (!iso) return '';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return '';
  return `${dois(d.getHours())}:${dois(d.getMinutes())}`;
}

// "DD/MM HH:MM".
export function diaMesHora(iso?: string | null): string {
  if (!iso) return '';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return '';
  return `${dois(d.getDate())}/${dois(d.getMonth() + 1)} ${horaCurta(iso)}`;
}

// O dia da marcação é diferente do dia da formação?
export function ehOutroDia(marcadaIso?: string | null, formacaoIso?: string | null): boolean {
  if (!marcadaIso || !formacaoIso) return false;
  const a = new Date(marcadaIso);
  const b = new Date(formacaoIso);
  if (Number.isNaN(a.getTime()) || Number.isNaN(b.getTime())) return false;
  return (
    a.getFullYear() !== b.getFullYear() ||
    a.getMonth() !== b.getMonth() ||
    a.getDate() !== b.getDate()
  );
}

// Quando a presença foi registrada/avaliada (usa avaliada_em quando houver).
export function quandoMarcou(l: InscritoPresenca): string | null {
  return l.avaliada_em || l.registrada_em;
}